import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propArrayShape, propBool, propFunc, propShape, } from '../../../../helpers/custom-prop-types';
import { slideSearchPageHelper } from '../../../../helpers/page/SlideSearch';
import { useArrayWithIndex } from '../../../../helpers/use/useArray';
import SlideSearchItem from '../../Common/Item/SlideSearchItem';
import SlideSearchItemSkeleton from '../../Common/Item/SlideSearchItemSkeleton';
const ContentLikeness = (props) => {
    const { list, loading, onChange, selectMap, unit } = props;
    const dummies = useArrayWithIndex(4);
    if (!loading && !list.length) {
        return null;
    }
    return (_jsxs("div", Object.assign({ className: 'content_likeness_box' }, { children: [_jsx("h4", Object.assign({ className: 'content_likeness_title' }, { children: "\u985E\u4F3C\u3059\u308B\u30B9\u30E9\u30A4\u30C9" })), _jsx("ul", Object.assign({ className: 'content_likeness_items' }, { children: loading
                    ? dummies.map(({ index }) => (_jsx("li", Object.assign({ className: 'content_likeness_item' }, { children: _jsx(SlideSearchItemSkeleton, {}, index) }), index)))
                    : list.map((v) => {
                        const uuid = slideSearchPageHelper.getSlideResponseKeyFromUnitValue(v, unit.value);
                        return (_jsx("li", Object.assign({ className: 'content_likeness_item' }, { children: _jsx(SlideSearchItem, { checked: !!selectMap[uuid], item: v, items: [v], onChange: onChange, unit: unit, uuid: uuid }) }), `${v.slideId}_${v.pageId}`));
                    }) }))] })));
};
ContentLikeness.propTypes = {
    list: propArrayShape().isRequired,
    loading: propBool().isRequired,
    onChange: propFunc().isRequired,
    selectMap: propShape().isRequired,
    unit: propShape().isRequired,
};
export default ContentLikeness;
